import { debounce, waitFor } from '../../../CodesThatsGottaGoSomewhereElse';
import { ActiveObject, resolve } from '../../Container';
import { AccountModel } from '../../account/AccountModel';
import { accountReadonlyPopup } from '../../account/AccountReadonlyPopup';
import { BoardUsageModel } from '../../account/BoardUsageModel';
import { PopupManager } from '../../popups/PopupManager';
import { BoardInfo } from '../BoardInfo';
import { boardLimitExceededPopup } from '../BoardLimitExceededPopup';
import { EditorModeInfo } from '../EditorModeInfo';
import { EditorOptions } from '../EditorOptions';
import { EditorSession } from '../EditorSession';
import { MyRoleInfo } from '../MyRoleInfo';
import { ToolManager } from '../tooling/ToolManager';
import { ViewMode } from './ViewMode';

export class ViewModeMechanics extends ActiveObject {

    @resolve(AccountModel) private readonly account!: AccountModel;
    @resolve(BoardUsageModel) private readonly boardLimit!: BoardUsageModel;
    @resolve(EditorOptions) private readonly options!: EditorOptions;
    @resolve(EditorSession) private readonly session!: EditorSession;
    @resolve(PopupManager) private readonly popups!: PopupManager;
    @resolve(ToolManager) private readonly tools!: ToolManager;

    public start() {
        const syncDebounced = debounce(() => this.sync(), 0);
        this.burden(
            this.session.observe(EditorModeInfo, syncDebounced),
        );
        this.sync();
    }

    private sync = () => {
        const mode = this.session.get(EditorModeInfo);
        if (mode.id !== ViewMode.id) return;
        this.tools.setEnabled([]);
        this.tools.setVisible([]);
        this.invokeBoardLimitExceededPopupIfApplicable();
        this.invokeExpiredPopupIfApplicable();
    };

    private async invokeBoardLimitExceededPopupIfApplicable() {
        if (!this.options.ui) return;
        const { canParticipate } = this.session.get(MyRoleInfo);
        if (!canParticipate) return;
        const board = this.session.get(BoardInfo);
        if (this.boardLimit.isBoardActive(board.id)) return;
        await waitFor(1000);
        await this.popups.invoke(boardLimitExceededPopup());
    }

    private async invokeExpiredPopupIfApplicable() {
        if (!this.options.ui) return;
        const { canParticipate } = this.session.get(MyRoleInfo);
        if (!canParticipate) return;
        const readonly = !!this.account.plan.features.readonly;
        if (!readonly) return;
        await waitFor(1000);
        await this.popups.invoke(accountReadonlyPopup());
    }
}
